import React from 'react';
import ModuleReservation from '../components/ModuleReservation';

const TransportPMRPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      {/* Header */}
      <div className="relative bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white py-16 px-4 border-b-4 border-[#e2b13c] overflow-hidden">
        {/* Image de fond - Aéroport Lille */}
        <div 
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: 'url(/images/aeroport-lille.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-black mb-6 text-[#e2b13c] drop-shadow-lg">
            Transport PMR à Lille et dans les Weppes : Bienveillance & Aide
          </h1>
          <h2 className="text-2xl font-semibold mb-8 text-gray-200 drop-shadow-md">
            Un chauffeur aux petits soins pour les seniors et personnes à mobilité réduite
          </h2>
          <div className="text-lg leading-relaxed text-gray-300 max-w-3xl mx-auto bg-black bg-opacity-50 p-6 rounded-lg">
            <p className="mb-4">
              Service d'accompagnement dédié aux Personnes à Mobilité Réduite (non agréé CPAM, sans bon de transport). Nous prenons le temps nécessaire pour vous aider à vous installer.
            </p>
            <p className="font-semibold text-[#e2b13c]">
              Vos déambulateurs et fauteuils pliants sont les bienvenus. Service adapté aux personnes capables d'effectuer un transfert vers un siège passager classique.
            </p>
          </div>
        </div>
      </div>

      {/* Section Informations */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-[#0f172a] p-6 rounded-lg border-2 border-[#e2b13c]">
            <h3 className="text-xl font-bold text-[#e2b13c] mb-3">✅ Notre Service Inclut</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Aide à l'installation dans le véhicule</li>
              <li>• Transport de déambulateurs et fauteuils pliants</li>
              <li>• Accompagnement bienveillant</li>
              <li>• Temps d'attente si nécessaire</li>
              <li>• Conduite souple et sécurisée</li>
            </ul>
          </div>
          <div className="bg-[#0f172a] p-6 rounded-lg border-2 border-[#e2b13c]">
            <h3 className="text-xl font-bold text-[#e2b13c] mb-3">⚠️ Important à Savoir</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Service non agréé CPAM (pas de bon de transport)</li>
              <li>• Le passager doit pouvoir effectuer un transfert vers un siège</li>
              <li>• Fauteuils roulants : uniquement modèles pliants</li>
              <li>• Tarif fixe sans supplément pour l'aide</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Module de Réservation (MÊME QUE PAGE D'ACCUEIL) */}
      <div className="py-16 px-4">
        <ModuleReservation />
      </div>
    </div>
  );
};

export default TransportPMRPage;